import Image from 'next/legacy/image';
import React from 'react';

import { useExperimentStatus } from '@/flags/use-experiments';

import { ContentSlider } from './ContentSlider.component';

export interface Image {
  source: string;
  altText: string;
  id: string;
}

interface ImageSliderProps {
  images: Image[];
}

export const ImageSlider = (props: ImageSliderProps) => {
  const lightboxEnabled = useExperimentStatus('feature-lightbox');

  return (
    <div css={{ paddingBottom: '32px' }}>
      <ContentSlider
        lightboxItems={
          lightboxEnabled
            ? props.images.map((image) => ({
                src: image.source,
                alt: image.altText,
                width: 1200,
                height: 1200,
              }))
            : undefined
        }
      >
        {props.images.map((image, index) => (
          <Image
            src={image.source}
            key={image.id}
            alt={image.altText}
            // 6x4 aspect ratio
            width={600}
            height={400}
            layout="responsive"
            objectFit="cover"
            priority={index === 0}
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        ))}
      </ContentSlider>
    </div>
  );
};
